import React, { lazy, Suspense, useState, useContext, useEffect } from 'react';
import { Spin } from 'antd'
import { Navigate, useRoutes, useLocation } from "react-router-dom";
import Mine, { Setting, Invoice, Address } from "./pages/Mine";
/* import Login, { Register, Resetpwd, Protocol } from "./pages/Login";
import Home from './pages/Home';
import List, { OeList } from './pages/List';
import Order, { OrderDetail } from "./pages/Mine/Order";
import Carsearch from "./pages/Carsearch";
import PartDtl, { PidDtl } from './pages/PartDtl'
import ConfirmOrder from './pages/ConfirmOrder'
import Cart from './pages/Cart'
import PaySuccess from './pages/PaySuccess'
import WechatPay from './pages/WechatPay'
import Doubt from "./pages/Doubt";
import Buypath from "./pages/Buypath";
import Contactus from "./pages/Contactus";
import Aboutus from "./pages/Aboutus";
import Canvastest from "./pages/Canvastest";
import Morepage from "./pages/Morepage";
import Enquery, { EnquerySuccess } from "./pages/Enquery"; */

import Vin, { VinDetailPage, Search, PartSearchPage } from '@/pages/Epc'
import KeepAlive from 'react-activation'
import lazyLoad from './lazyLoad';
import MainContext from './stores/stores';

/* const rootRouter: any = [
	{
		path: "/",
		element: <Navigate to="/home"/>
	},
	{
		path: "/login",
		element: <Login/>,
	},
  {
    path: '/register',
    element: <Register/>
  },
  {
    path: '/resetpwd',
    element: <Resetpwd/>
  },
  {
    path: '/mine',
    element: <Mine/>,
    children: [
      {
        path: '/mine/order',
        element: <Order/>,
      },
      {
        path: '/mine/order/detail',
        element: <OrderDetail/>,
      },
      {
        path: '/mine/setting',
        element: <Setting/>,
      },
      {
        path: '/mine/invoice',
        element: <Invoice/>,
      },
      {
        path: '/mine/address',
        element: <Address/>,
      },

    ]
  },
	{
		path: '/home',
		element: <Home/>
	},
	{
		path: '/vin',
		element: <List from='vin'/>
	},
  {
    path: '/cjh',
    element: <KeepAlive cacheKey="UNIQUE_ID"><List from='cjh'/></KeepAlive>
  },
	{
		path: '/code',
		element: <List from='oe'/>
	},
  {
    path: '/adZone',
    element: <List from='adZone'/>
  },
  {
    path: '/partsZone',
    element: <List from='parts_categories'/>
  },
  { 
    path: '/oe',
    element: <OeList/>
  },
  {
    path: '/carsearch',
    element: <Carsearch/>
  },
	{
		path: '/carsearch/list',
		element: <List from='car'/>
	},
  {
    path: '/class',
    element: <List from="class" />
  },
	{
		path: '/partDtl',
		element: <PartDtl/>
	},
  {
    path: '/pidDtl',
    element: <PidDtl/>
  },
  {
    path: '/oe/pidDtl',
    element: <PidDtl/>
  },
  {
    path: '/cjh/pidDtl',
    element: <PidDtl/>
  },
  {
    path: '/adZone/pidDtl',
    element: <PidDtl/>
  },
  {
    path: '/confirmOrder',
    element: <ConfirmOrder/>
  },
  {
    path: '/cart',
    element: <Cart/>
  },
  {
    path: '/paySuccess',
    element: <PaySuccess/>
  },
  {
    path: '/wechatPay',
    element: <WechatPay/>
  },
  {
    path: '/doubt',
    element: <Doubt/>
  },
  {
    path: '/buypath',
    element: <Buypath/>
  },
  {
    path: '/contactus',
    element: <Contactus/>
  },
  {
    path: '/aboutus',
    element: <Aboutus/>
  },
  {
    path: '/canvastest',
    element: <Canvastest/>
  },
  {
    path: '/morepage/:code',
    element: <Morepage/>
  },
  {
    path: '/epc',
    element: <Search />
  },
  {
    path: '/epc/vin',
    element: <Vin />
  },
  {
    path: '/epc/vin/detail',
    element: <VinDetailPage />
  },
  {
    path: '/epc/part',
    element: <PartSearchPage />
  },
  {
    path: '/oe/part',
    element: <PartSearchPage />
  },
  {
    path: '/enquery',
    element: <Enquery />
  },
  {
    path: '/enquery/success',
    element: <EnquerySuccess />
  },

]; */

const HomeLoad = lazyLoad(lazy(() => import('./pages/Home')))
const Map = lazyLoad(lazy(() => import('./pages/Home/Map')))
// const CjHList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'cjh'})

const CjHList = lazyLoad(lazy(() => import('./pages/List/CjhList')))


const VinList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'vin'})
const CodeList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'oe'})
const AdZoneList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'adZone'})
const PartsZoneList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'parts_categories'})
// const OeSList = lazyLoad(lazy(() => import('./pages/List/OeList')))
const OeSList = lazyLoad(lazy(() => import('./pages/List/PidList')))
const CarList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'car'})
const ClassList = lazyLoad(lazy(() => import('./pages/List/List')), {from: 'class'})

const rootRouter: any = [
	/* {
		path: "/",
		element: <Navigate to="/home"/>
	}, */
	{
		path: "/login",
		element: lazyLoad(lazy(() => import('./pages/Login/Login')))
	},
	{
		path: "/googleauth",
		element: lazyLoad(lazy(() => import('./pages/Login/Googleauth')))
	},
  {
    path: '/register',
    element: lazyLoad(lazy(() => import('./pages/Login/Register'))),
  },
  {
    path: '/resetpwd',
    element: lazyLoad(lazy(() => import('./pages/Login/Restpwd'))),
  },
  {
    path: '/protocol/user',
    element: lazyLoad(lazy(() => import('./pages/Login/Protocol')), { from: 'user' }),
  },
  {
    path: '/protocol/privacy',
    element: lazyLoad(lazy(() => import('./pages/Login/Protocol')), { from: 'privacy' }),
  },
  {
    path: '/mine',
    element: <Mine/>,
    children: [
      {
        path: 'order',
        element: lazyLoad(lazy(() => import('./pages/Mine/Order'))),
      },
      {
        path: 'order/detail',
        element: lazyLoad(lazy(() => import('./pages/Mine/Order/Detail'))),
      },
			{
			  path: 'aftersales',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Aftersales'))),
			},
			{
			  path: 'aftersales/detail',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Aftersales/Detail'))),
			},
      {
        path: 'setting',
        element: lazyLoad(lazy(() => import('./pages/Mine/Setting'))),
      },
      {
        path: 'invoice',
        element: lazyLoad(lazy(() => import('./pages/Mine/Invoice'))),
      },
      {
        path: 'invoice/history',
        element: lazyLoad(lazy(() => import('./pages/Mine/InvoiceHistory'))),
      },
      {
        path: 'address',
        element: lazyLoad(lazy(() => import('./pages/Mine/Address'))),
      },
      {
        path: 'company',
        element: lazyLoad(lazy(() => import('./pages/Mine/Company'))),
      },
      {
        path: 'reconciliation',
        element: lazyLoad(lazy(() => import('./pages/Mine/Reconciliation'))),
      },
      {
        path: 'copewith',
        element: lazyLoad(lazy(() => import('./pages/Mine/Copewith'))),
      },
			{
			  path: 'copewith/detail',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Copewith/Detail'))),
			},
			{
			  path: 'copewith/pay',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Copewith/Pay'))),
			},
			{
			  path: 'invitation',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Invitation'))),
			},
      {
			  path: 'poster',
			  element: lazyLoad(lazy(() => import('./pages/Mine/Poster'))),
			},
    ]
  },
	{
		path: '/home',
		element: <KeepAlive cacheKey="UNIQUE_ID_HOME" name="UNIQUE_ID_HOME" key='/home'>{HomeLoad}</KeepAlive>
	},
  {
		path: '/map',
		element: <KeepAlive cacheKey="UNIQUE_ID_MAP" name="UNIQUE_ID_MAP" key='/map'>{Map}</KeepAlive>
	},
  
	{
		path: '/vin',
		// element: <List from='vin'/>
    element: <KeepAlive cacheKey="UNIQUE_ID_VIN" name="UNIQUE_ID_VIN" key='/vin'>{VinList}</KeepAlive>
	},
  {
    path: '/cjh',
    element: <KeepAlive cacheKey="UNIQUE_ID_CJH" name="UNIQUE_ID_CJH" key='/cjh'>
      {CjHList}
    </KeepAlive>
  },
	{
		path: '/code',
		// element: <List from='oe'/>
    element: <KeepAlive cacheKey="UNIQUE_ID_CODE" name="UNIQUE_ID_CODE" key='/code'>
      {CodeList}
    </KeepAlive>
	},
  {
    path: '/adZone',
    // element: <List from='adZone'/>
    element: <KeepAlive cacheKey="UNIQUE_ID_ADZONE" name="UNIQUE_ID_ADZONE" key='/adZone'>
      {AdZoneList}
    </KeepAlive>
  },
  {
    path: '/partsZone',
    // element: <List from='parts_categories'/>
    element: <KeepAlive cacheKey="UNIQUE_ID_PartsZone" name="UNIQUE_ID_PartsZone" key='/partsZone'>
      {PartsZoneList}
    </KeepAlive>
  },
  { 
    path: '/oe',
    element: <KeepAlive cacheKey="UNIQUE_ID_OE" name="UNIQUE_ID_OE" key='/oe'>
      {OeSList}
    </KeepAlive>
  },
  {
    path: '/partHistoryList',
    element: lazyLoad(lazy(() => import('./pages/List/PartHistoryList')))
  },
  {
    path: '/carsearch',
    element: lazyLoad(lazy(() => import('./pages/Carsearch/Carsearch')))
  },
	{
		path: '/carsearch/list',
		// element: <List from='car'/>
    element: <KeepAlive cacheKey="UNIQUE_ID_CAR" name="UNIQUE_ID_CAR" key='/carsearch/list'>
      {CarList}
    </KeepAlive>
	},
  {
    path: '/class',
    // element: <List from="class" />
    element: <KeepAlive cacheKey="UNIQUE_ID_CLASS" name="UNIQUE_ID_CLASS" key='/class'>
      {ClassList}
    </KeepAlive>
  },
	{
		path: '/partDtl',
		element: lazyLoad(lazy(() => import('./pages/PartDtl/PartDtl')))
	},
  {
    path: '/pidDtl',
    element: lazyLoad(lazy(() => import('./pages/PartDtl/PidDtl')))
  },
  {
    path: '/oe/pidDtl',
    element: lazyLoad(lazy(() => import('./pages/PartDtl/PidDtl')))
  },
  {
    path: '/cjh/pidDtl',
    element: lazyLoad(lazy(() => import('./pages/PartDtl/PidDtl')))
  },
  {
    path: '/adZone/pidDtl',
    element: lazyLoad(lazy(() => import('./pages/PartDtl/PidDtl')))
  },
  {
    path: '/car/pidDtl',
    element: lazyLoad(lazy(() => import('./pages/PartDtl/PidDtl')))
  },
  {
    path: '/confirmOrder',
    element: lazyLoad(lazy(() => import('./pages/ConfirmOrder')))
  },
  {
    path: '/cart',
    element: lazyLoad(lazy(() => import('./pages/Cart')))
  },
  {
    path: '/paySuccess',
    element: lazyLoad(lazy(() => import('./pages/PaySuccess')))
  },
  {
    path: '/wechatPay',
    element: lazyLoad(lazy(() => import('./pages/WechatPay')))
  },
  {
    path: '/newPay',
    element: lazyLoad(lazy(() => import('./pages/WechatPay/NewPay')))
  },
  {
    path: '/doubt',
    element: lazyLoad(lazy(() => import('./pages/Doubt')))
  },
  {
    path: '/buypath',
    element: lazyLoad(lazy(() => import('./pages/Buypath')))
  },
  {
    path: '/contactus',
    element: lazyLoad(lazy(() => import('./pages/Contactus')))
  },
  {
    path: '/aboutus',
    element: lazyLoad(lazy(() => import('./pages/Aboutus')))
  },
  {
    path: '/canvastest',
    element: lazyLoad(lazy(() => import('./pages/Canvastest')))
  },
  {
    path: '/morepage/:code',
    element: lazyLoad(lazy(() => import('./pages/Morepage')))
  },
  {
    path: '/epc',
    element: <Search/>
  },
  {
    path: '/epc/vin',
    element: <Vin/>
  },
  {
    path: '/epc/vin/detail',
    element: <VinDetailPage/>
  },
  {
    path: '/epc/part',
    element: <PartSearchPage/>
  },
  {
    path: '/oe/part',
    element: lazyLoad(lazy(() => import('./pages/Epc/PartSearchPage')))
  },
  {
    path: '/enquery',
    element: lazyLoad(lazy(() => import('./pages/Enquery')))
  },
  {
    path: '/enquery/success',
    element: lazyLoad(lazy(() => import('./pages/Enquery/EnquerySuccess')))
  }
];


const Router = () => {
  const { commonStore, setCommonStore } = useContext(MainContext)
  const [route, setRoute] = useState<any[]>(rootRouter)
  const location = useLocation();
  useEffect(() => {
    if(commonStore.homeUrl) {
      setRoute(prev => [
        { 
          path: '/', 
          element: <Navigate
            to={commonStore.homeUrl}
            replace
            // state={{ from: location.pathname }} // 保留原始路径状态
          /> 
        },
        ...prev.slice(0) // 保留原有路由配置
      ]);
    }
  }, [commonStore.homeUrl])
	const routes = useRoutes(route);
  return routes
	 ;
};

export default Router